const Gallery= (wrapper) => {
    if(!wrapper) return;

    let current = 0
    const items = wrapper.querySelectorAll("*");
    const nextButton = wrapper.parentElement.querySelector(".button-next");
    const prevButton = wrapper.parentElement.querySelector(".button-previous");

    const updateItems = () => {
    items.forEach((item, index) => {
        item.style.visibility = index === current ? "visible" : "hidden";
    });
    };

    const next = () => {
    current++;
    if (current >= items.length) current = 0;
    updateItems();
    };

    const prev = () => {
    current--;
    if (current < 0) current = items.length - 1;
    updateItems();
    };

    if(nextButton) nextButton.addEventListener("click", next);
    if(prevButton) prevButton.addEventListener("click", prev);

    updateItems();
};

export default Gallery;
